import React, { useState, useEffect } from "react"

//controls
import { Button, Col, Row, Label } from "reactstrap"

//react form
import { FormProvider, useForm, Controller } from "react-hook-form"

//navigation
import { Link, useNavigate, useParams } from "react-router-dom"

//validation
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"

//redux
import { useSelector, useDispatch } from "react-redux"

//custom hooks
import { useDeepCompareEffect, useUserDetail } from "hooks"

import Select from "react-select"

//Date filter
import Moment from "moment"

import {
  addCentre as onAddCentre,
  updateCentre as onUpdateCentre,
  getCentreTypes as onGetCentreTypes,
} from "store/actions"

import Spinners from "components/Common/Spinner"
import { isEmpty } from "lodash"

import {
  TextInput,
  DropdownInput,
  DateInput,
  NumberInput,
  ToggleInput,
} from "components/Common/Controls"
import { EnumRoleTypes } from "helpers/enum_helper"

function BasicInfoTab({ centre, loading }) {
  const navigate = useNavigate()
  const { id } = useParams()
  const dispatch = useDispatch()
  const [isLoading, setLoading] = useState(loading)
  const { centretypes } = useSelector(state => state.healthday)
  /**
   * Form Validation Schema
   */
  const schema = yup.object().shape({
    Centre: yup.string().required("Required"),
    Postcode: yup.string().required("Required"),
    CentreTypes: yup.object().required("Required"),
    Active: yup.bool(),
  })

  const methods = useForm({
    mode: "onChange",
    defaultValues: {
      Centre: "",
      Postcode: "",
      CentreTypes: null,
      Active: true,
    },
    resolver: yupResolver(schema),
  })
  const { reset, control, formState, setValue, getValues, trigger, watch } =
    methods
  const { errors, isValid } = formState

  useDeepCompareEffect(() => {
    function updateProfileState() {
      //reset form with server data
      dispatch(onGetCentreTypes())
      reset(centre)
    }

    updateProfileState()
  }, [dispatch])

  const onCancelClick = () => {
    navigate("/centres")
  }

  const handleSave = () => {
    trigger() //for form validation
    if (isValid) {
      if (isEmpty(centre)) {
        dispatch(onAddCentre(getValues()))
      } else {
        dispatch(onUpdateCentre(getValues()))
      }
      if (!isEmpty(id)) {
        navigate("/centres")
      }
    }
  }

  if (isLoading) {
    return <Spinners setLoading={setLoading} />
  }

  return (
    <FormProvider {...methods}>
      <Row>
        <Col sm="4">
          <div className="mb-3">
            <TextInput label="Centre Name" id="Centre" required={true} />
          </div>
        </Col>
      </Row>
      <Row>
        <Col sm="4">
          <div className="mb-3">
            <TextInput label="Postcode" id="Postcode" required={true} />
          </div>
        </Col>
      </Row>
      <Row>
        <Col sm="4">
          <div className="mb-3">
            <DropdownInput
              label="Centre Type"
              id="CentreTypes"
              required={true}
              items={centretypes}
              itemlabel="CentreType"
              itemvalue="CentreTypeID"
            />
          </div>
        </Col>
      </Row>

      <Row>
        <div className="mb-3">
          <ToggleInput label="Active" id="Active" />
        </div>
      </Row>

      <div className="d-flex flex-wrap gap-2">
        <Button color="primary" className="btn" onClick={handleSave}>
          {isEmpty(centre) ? "Save" : "Update"}
        </Button>
        <Button type="button" color="secondary" onClick={onCancelClick}>
          Cancel
        </Button>
      </div>
    </FormProvider>
  )
}
export default BasicInfoTab
